module.exports = __webpack_public_path__ + "static/media/pin-3-3.9437f690.svg";